<script setup lang="ts">
import { onMounted, toRefs,watch,reactive, ref } from "vue";
import { errorAlert } from "../plugins/alert";
import { uuid } from 'vue-uuid';

const props = defineProps({
    label: {
      type:String,
      required:true
    },
    onChange: {
      type:Function,
      required:true
    },
    value:{
      type:Boolean,
      required:true
    },
    valueOptions:{
      type:Object,
      default: () => {
        return null;
      }
    }
})

const { value } = toRefs(props);
const uuidValue = uuid.v1();
const checkRef = ref()
const checkValue = ref(props.value);
watch(checkValue,(newValue,oldValue) => {
  if (props.valueOptions !== null) {
    props.onChange(newValue,props.valueOptions);
  } else {
    props.onChange(newValue);
  }
});
watch(value,(newValue,oldValue) => {
  checkValue.value = newValue;
});
</script>

<style scoped lang='sass'>
</style>

<template>
  <div class="flex items-center justify-between">
    <div class="flex-grow flex flex-col">
        <div class="text-sm md:text-base font-semibold text-gray-900 text-right mr-1" v-html="label"></div>
    </div>
    <label :for="uuidValue" class="flex items-center cursor-pointer relative">
        <input ref="checkRef" :id="uuidValue" type="checkbox" class="sr-only" v-model="checkValue">
        <span class="toggle-bg bg-gray-200 border-2 border-gray-200 h-6 w-11 rounded-full"></span>
    </label>
  </div>
</template>

